import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';

interface SmallIconButtonProps {
    IconComponent: React.ComponentType<{ style: { fontSize: React.CSSProperties['fontSize'] } }>;
    onClick?: () => void;
    tooltip?: string;
    color?: 'primary' | 'secondary' | 'inherit';
}

const SmallIconButton = ({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    IconComponent,
    onClick,
    tooltip,
    color = 'primary',
}: SmallIconButtonProps) => {
    const button = (
        <IconButton color={color} onClick={onClick} style={{ padding: 10 }}>
            <IconComponent style={{ fontSize: 16 }} />
        </IconButton>
    );

    if (tooltip) {
        return (
            <Tooltip title={tooltip}>
                {button}
            </Tooltip>
        );
    }

    return button;
};

export default SmallIconButton;
